/** PURE_IMPORTS_START .._.._Observable,.._.._operator_merge PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { merge } from '../../operator/merge';
Observable.prototype.merge = merge;
//# sourceMappingURL=merge.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/merge.js
// module id = 685
// module chunks = 0